// extracted by css-extract-rspack-plugin
var _1 = "vJvRYfVmbMdvfGTk";
var _2 = "RLeqefbEhu0YQTuc";
var _3 = "X5b4_7Kgu8c8f7qS";
var _4 = "V8hlGfVCOEIcFvo8";
export { _1 as "base", _2 as "left", _3 as "right", _4 as "rounded" }
